import './common.css';

// Component returning a button with an X

function ExitButton({ onClick, style }) {

    return (
        <button
            className="ExitButton"
            onClick={onClick}
            style={style}
        >
            <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                width="20"
                height="20"
            >
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
        </button>
    );

}

export default ExitButton;